import React from "react";
import { Minus, Plus, Trash2 } from "lucide-react";
import Button from "../../../components/Button";
import styles from "../css/inventoryItemDetail.module.css";

export const ExpiryModal = ({
  showExpiryModal,
  setShowExpiryModal,
  expiryList,
  decExpiryCount,
  incExpiryCount,
  updateExpiryAt,
  removeExpiryAt,
  readOnly = false,
}) => {
  if (!showExpiryModal) return null;

  return (
    <div className={styles.modalOverlay} role="dialog" aria-modal="true">
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2>View Expiry</h2>
          <button
            className={styles.modalCloseBtn}
            onClick={() => setShowExpiryModal(false)}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.icdToolbar}>
            <div className={styles.icdCountControl}>
              {!readOnly && (
                <>
                  <button
                    type="button"
                    className={styles.icdIconBtn}
                    onClick={decExpiryCount}
                    aria-label="Decrease"
                  >
                    <Minus size={16} />
                  </button>
                  <span className={styles.icdCount}>{expiryList.length}</span>
                  <button
                    type="button"
                    className={styles.icdIconBtn}
                    onClick={incExpiryCount}
                    aria-label="Increase"
                  >
                    <Plus size={16} />
                  </button>
                </>
              )}
              {readOnly && (
                <span className={styles.icdCount}>{expiryList.length}</span>
              )}
            </div>
            <div className={styles.icdToolbarLabel}>Expiry</div>
          </div>
          <div className={styles.icdChipsRow}>
            {expiryList.map((d, idx) => (
              <div className={styles.icdChip} key={idx}>
                <input
                  className={styles.icdChipInput}
                  type="date"
                  value={d}
                  onChange={readOnly ? undefined : (e) => updateExpiryAt(idx, e.target.value)}
                  readOnly={readOnly}
                  disabled={readOnly}
                />
                {!readOnly && expiryList.length > 1 && (
                  <button
                    type="button"
                    className={styles.icdDeleteBtn}
                    onClick={() => removeExpiryAt(idx)}
                    aria-label="Remove"
                  >
                    <Trash2 size={14} />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.modalFooter}>
          <Button variant="primary" onClick={() => setShowExpiryModal(false)}>
            {readOnly ? "Close" : "Save"}
          </Button>
        </div>
      </div>
    </div>
  );
};
